/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Select_HintInputs */

const cs_social_hub_select_hint = /** @type {(inputs: Social_Hub_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte inzerát — vygenerujte plakát, nahrajte vlastní média a publikujte.`)
};

const en_social_hub_select_hint = /** @type {(inputs: Social_Hub_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a listing to generate a poster, upload your own media, and publish.`)
};

/**
* | output |
* | --- |
* | "Select a listing to generate a poster, upload your own media, and publish." |
*
* @param {Social_Hub_Select_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_select_hint = /** @type {((inputs?: Social_Hub_Select_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Select_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_select_hint(inputs)
	return cs_social_hub_select_hint(inputs)
});